module.exports = __webpack_public_path__ + "static/media/selectedDispatchedLetter.ae291722.svg";